import { Fragment } from 'react';
import { EntitySwitch } from '@backstage/plugin-catalog';
import {
  hasCatalogProcessingErrors,
  isOrphan,
  EntityOrphanWarning,
  EntityProcessingErrorsPanel,
} from '@backstage/plugin-catalog';
import type { EntityContentLayoutProps } from '@backstage/plugin-catalog-react/alpha';
import { useStyles } from './EntityContentLayout.styles';

export function EntityContentLayout({ cards }: EntityContentLayoutProps) {
  const infoCards = cards.filter(c => c.type === 'info');
  const contentCards = cards.filter(c => !c.type || c.type === 'content');

  const classes = useStyles({
    infoCards: !!infoCards.length,
  });

  return (
    <>
      <div className={classes.warningArea}>
        <EntitySwitch>
          <EntitySwitch.Case if={isOrphan}>
            <EntityOrphanWarning />
          </EntitySwitch.Case>
        </EntitySwitch>
        <EntitySwitch>
          <EntitySwitch.Case if={hasCatalogProcessingErrors}>
            <EntityProcessingErrorsPanel />
          </EntitySwitch.Case>
        </EntitySwitch>
      </div>

      <div className={classes.root}>
        {infoCards.length > 0 && (
          <div className={classes.infoArea}>
            {infoCards.map((card, i) => (
              <Fragment key={card.element.key ?? i}>{card.element}</Fragment>
            ))}
          </div>
        )}
        <div className={classes.mainContent}>
          {contentCards.length > 0 && (
            <div className={classes.contentArea}>
              {contentCards.map((card, i) => (
                <Fragment key={card.element.key ?? i}>{card.element}</Fragment>
              ))}
            </div>
          )}
        </div>
      </div>
    </>
  );
}
